<div class="d-flex align-items-center justify-content-between w-100" [formGroup]="form">
    <pmt-datepicker class="flex-grow-1" formControlName="date" />
    <div class="ms-1">
        <timepicker [showMeridian]="false" [showSpinners]="false" formControlName="time" />
    </div>
</div>
